import React from "react";
import logo from "../images/amotive-orange-revert-white-orange-symbol.png";

function FooterMobile() {
  return (
    <footer className="am-footer-mobile">
      <img
        src={logo}
        alt="Amotive"
        className="am-footer-mobile-logo"
      />
    </footer>
  );
}

export default FooterMobile;
